export default {
  warning_label:
    'Si no seleccionás esta opción se genera una factura de venta como consumidor final.',
  input_nit: {
    placeholder: 'Ingresa un {typeDoc} | Ingresa una {typeDoc}',
    error: {
      required: 'El campo de {typeDoc} es requerido | El campo de {typeDoc} es requerida',
      format: 'Debe especificar un {typeDoc} válido | Debe especificar una {typeDoc} válida'
    }
  },
  input_type_doc: {
    label: 'Tipo de Documento:'
  },
  input_economy_act: {
    label: 'Actividad económica:'
  }
}
